var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-view",style:({margin:_vm.margin})},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('input',{attrs:{"placeholder":_vm.placeholder,"clearable":true,"type":_vm.type},domProps:{"value":_vm.value},on:{"input":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }